import {
  Folders,
  Video,
  Videos,
} from '@client/new/pages/creator/library/models/library.domain';

export const getFoldersChildrenCount = (
  folders: Folders,
  videos: Videos,
  currentId: number,
) => {
  const folderCount = (folders || []).filter(
    (f) => f.parentId === currentId,
  ).length;
  const videosCount = (videos || []).filter(
    (f) => f.folderId === currentId,
  ).length;
  const total = folderCount + videosCount;

  return `${total} ${total === 1 ? 'item' : 'items'}`;
};

export const getVideosScope = (
  data: Videos,
  openedFolderId: number | null,
  searchText: string,
) => {
  if (openedFolderId === null && searchText) return data;
  return data.filter((f) => f.folderId === openedFolderId);
};

export const getFoldersScope = (
  data: Folders,
  openedFolderId: number | null,
  searchText: string,
) => {
  if (openedFolderId === null && searchText) return data;
  return data.filter((f) => f.parentId === openedFolderId);
};

export type SortFields = 'updatedAt' | 'name';
export type ContentFilters = 'short' | 'long' | 'extras-video';
export type DescriptionFilters = 'yes' | 'no';

export const sortList = (
  a: { name: string; updatedAt: string },
  b: { name: string; updatedAt: string },
  field: SortFields,
  isAsc: boolean,
) => {
  if (field == 'name') {
    return isAsc ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
  }

  if (field == 'updatedAt') {
    return new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime() &&
      isAsc
      ? -1
      : 1;
  }

  return 0;
};

export const contentFilter = (
  value: Video,
  contentFilter: ContentFilters | null,
): Video | boolean => {
  if (!contentFilter) {
    return value;
  }
  if (contentFilter === 'extras-video') {
    return value.tags?.includes('extras-video') ? value : false;
  }
  return value.type === contentFilter;
};

export const descriptionFilter = (
  value: Video,
  descriptionFilter: DescriptionFilters | null,
): Video | boolean => {
  if (!descriptionFilter) {
    return value;
  }

  return (
    (value.description && descriptionFilter === 'yes') ||
    (!value.description && descriptionFilter === 'no')
  );
};

export const nameMatches = (t: string) => (v: { name: string }) =>
  v.name.toLowerCase().includes(t.toLowerCase());
